/* eslint-disable import/no-cycle */
/* eslint-disable no-bitwise */
import classNames from 'classnames'
import { useMemo, useState } from 'react'
import { injectIntl } from 'react-intl'
import { Tooltip } from 'reactstrap'
import symbolTooltip from 'assets/img/symbol-tooltip.png'
import { replaceParamsInString, uuidv4 } from 'helpers/utils'
import { getLabelConfigById } from './utils'

function InjectMassage({ id, hiddenHelpText, params = {} }) {
  const [tooltipOpen, setTooltipOpen] = useState(false)

  const tooltipId = useMemo(() => `tooltip-${uuidv4()}`, [])

  const { originalName, helpText } = useMemo(() => getLabelConfigById(id), [id])

  const isEnabledHelpText = useMemo(() => {
    return helpText && !hiddenHelpText
  }, [helpText, hiddenHelpText])

  const translateLabel = useMemo(() => {
    return replaceParamsInString(id, originalName, params)
  }, [id, originalName, params])

  return (
    <span className="tooltip-help-text">
      <span
        color="secondary"
        className={classNames({ 'inline-block': isEnabledHelpText })}
      >
        {translateLabel}
      </span>
      {isEnabledHelpText && (
        <>
          &nbsp;
          <img
            className="align-middle -mt-1"
            src={symbolTooltip}
            width={16}
            height={16}
            alt=""
            id={tooltipId}
          />
          <Tooltip
            container="body"
            trigger="hover"
            placement="top"
            isOpen={tooltipOpen}
            target={tooltipId}
            toggle={() => setTooltipOpen(!tooltipOpen)}
          >
            {helpText}
          </Tooltip>
        </>
      )}
    </span>
  )
}

export default injectIntl(InjectMassage, { forwardRef: true })
